// features/premium/BillingToggle.tsx — Monthly/Annual billing switch.
import styled from 'styled-components';
import { media } from '@/theme/media';

export type BillingPeriod = 'monthly' | 'annual';
export interface BillingToggleProps {
  value: BillingPeriod;
  onChange: (period: BillingPeriod) => void;
}

const Seg = styled.div`
  display: inline-flex; gap: 2px; padding: 3px; border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.glassBg};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  ${media.mobile`width: 100%;`}
`;
const SegBtn = styled.button<{ $active: boolean }>`
  border: none; cursor: pointer; padding: 6px 14px; border-radius: ${({ theme }) => theme.radius.sm};
  font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ theme, $active }) => ($active ? theme.color.onAccent : theme.color.textMuted)};
  background: ${({ theme, $active }) => ($active ? theme.color.accentCyan : 'transparent')};
  ${media.mobile`flex: 1; text-align: center;`}
`;

const ITEMS: { id: BillingPeriod; label: string }[] = [
  { id: 'monthly', label: 'Monthly' },
  { id: 'annual', label: 'Annual' },
];

export function BillingToggle({ value, onChange }: BillingToggleProps) {
  return (
    <Seg role="group" aria-label="Billing period">
      {ITEMS.map((it) => (
        <SegBtn key={it.id} type="button" $active={value === it.id}
          aria-pressed={value === it.id} onClick={() => onChange(it.id)}>
          {it.label}
        </SegBtn>
      ))}
    </Seg>
  );
}
